import analytics from "web/script/analytics/analytics";
import requester from "web/script/modules/requester";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import Button from "web/react/components/button/button";
import BranchLink from "web/react/components/branch-link/branch-link";
import browser from "web/script/utils/browser";
import { RawBranchLink } from "web/script/utils/branch-io";
import environment from "web/script/modules/environment";

interface FollowDesignerButtonProps {
    lystId: number;
    registrationReason?: string;
    followedText: string;
    notFollowedText: string;
    isAuthenticated: string;
    isFollowing: string;
    openCustomerCaptureOverlay: (object) => void;
    analyticsParameters: [string, string, string];
    className: string;
}

export function FollowDesignerButton({
    lystId,
    registrationReason,
    followedText,
    notFollowedText,
    isAuthenticated,
    isFollowing,
    openCustomerCaptureOverlay,
    analyticsParameters,
    className,
}: FollowDesignerButtonProps): JSX.Element {
    const [following, setFollowing] = useState<boolean>(isFollowing != "false");
    const [isIos, setIsIos] = useState(false);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    function follow(): Promise<void> {
        return requester
            .post("/api/users/add/", `lyst_id=${lystId}`)
            .then(() => {
                setFollowing(true);
                analytics.event("Follow Button", "Follow - Success", undefined, true);
            })
            .catch(() => {
                analytics.event("Follow Button", "Follow - Error", undefined, true);
            });
    }

    function unFollow(): Promise<void> {
        return requester
            .post("/api/users/remove/", `lyst_id=${lystId}`)
            .then(() => {
                setFollowing(false);
                analytics.event("Follow Button", "Unfollow - Success", undefined, true);
            })
            .catch(() => {
                analytics.event("Follow Button", "Unfollow - Error", undefined, true);
            });
    }

    const pageSubType = environment.get("pageSubType");
    let buttonLabel = following ? followedText : notFollowedText;

    const [category, action, label] = analyticsParameters;

    function onClick(): void {
        analytics.event(category, action, label);
        if (isAuthenticated === "false") {
            openCustomerCaptureOverlay({
                designerId: lystId,
                registrationReason: registrationReason,
                captureType: "signup_du",
            });
        } else if (following) {
            unFollow();
        } else {
            follow();
        }
    }

    if (
        pageSubType &&
        pageSubType.startsWith("designer") &&
        isAuthenticated === "false" &&
        isIos &&
        environment.getFeature("mg_du_banner_ios_to_app")
    ) {
        return (
            <BranchLink
                title={buttonLabel}
                className={className}
                branchLink={RawBranchLink.DesignerUpdates}
                eventCategory={"get_updates_designer"}
                eventAction={"send_to_app"}
                eventLabel={"get_updates_button"}
                primaryButton
            />
        );
    }

    return (
        <Button
            styleType="primary"
            className={className}
            onClick={onClick}
            disabled={false}
            fullWidth={false}
            fullHeight={false}
            openInNewTab={false}
        >
            {buttonLabel}
        </Button>
    );
}

export default connect(null, { openCustomerCaptureOverlay })(FollowDesignerButton);
